<template>
  <div class="container">
    <h4 class="title is-4">{{displayedName}}</h4>

    <div class="container" v-if="object">
      <app-notify-on-object-event :id="object.id"/>
    </div>

    <div class="container" v-if="object && object.command_call_endpoint">
      <div class="spacer"><!-- --></div>
      <app-run-command-on-object :id="object.id" :endpointId="object.command_call_endpoint" />
    </div>

    <div class="buttons" style="margin-top: 2.5rem;">
      <b-button type="is-primary" class="is-small" @click="handleClickViewEvents">View Events</b-button>
      <b-button type="is-primary" class="is-small" @click="handleClickViewChart">View Chart</b-button>
      <b-button type="is-secondary" class="is-small" @click="handleClickEditObject">Edit Object</b-button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {beautifyObjectName} from "../utils/utils";
  import BButton from "buefy/src/components/button/Button";
  import NotifyOnObjectEvent from '../components/configure/NotifyOnObjectEvent';
  import RunCommandOnObject from '../components/configure/RunCommandOnObject';

  export default {
    name: "screen-object-quick-view",
    components: {
      BButton,
      appNotifyOnObjectEvent: NotifyOnObjectEvent,
      appRunCommandOnObject: RunCommandOnObject,
    },
    data() {
      return {
        object: null
      };
    },
    computed: {
      ...mapGetters('ui', ['loadingOverlay']),
      ...mapGetters('objects', ['objectById']),
      displayedName() {
        if (!this.object) {
          return 'Unknown Object';
        }

        return beautifyObjectName(this.object.name);
      }
    },
    methods: {
      handleClickViewEvents() {
        this.$router.push(`/events?objectTypeId=${this.object.object_type_id}&objectId=${this.object.id}&timeFrameId=${this.selectedTimeFrameId}`);
      },
      handleClickEditObject() {
        this.$router.push(`/configure/objects/${this.object.id}`);
      },
      handleClickViewChart() {
        this.$router.push(`/chart/${this.object.id}`);
      }
    },
    created() {
      this.object = this.objectById(this.$route.params.objectId);
    },
    mounted() {

    }
  }
</script>

<style scoped>
  .spacer {
    margin-top: 1.5rem;
  }
</style>
